// extracted by mini-css-extract-plugin
export default {"athletes":"athletes_athletes__T2rLJ","tabs-container":"athletes_tabs-container__RVCnt","text":"athletes_text__egdi4"};